import { i18n } from "@lingui/core"

import {
	mdiAccountSearch,
	mdiFire,
	mdiCashMultiple,
	mdiClipboardTextClock,
	mdiDomain,
	mdiStarCheckOutline,
	mdiStoreCheck,
	mdiStorePlus,
	mdiBallot,
	mdiCalendarBlankMultiple,
} from "@mdi/js"

import {
	BackgroundBabyPowder,
	BackgroundBlue,
	BackgroundDeepBlue,
	BackgroundLightBlue,
	BackgroundLilac,
	BackgroundRed,
	BackgroundTurquoise,
} from "./index"

export class DashboardCardInfo {
	public constructor(
		public background: any,
		public avatarIcon: string,
		public avatarColour: string,
		public title: string | null,
		public actionButton: string | null
	) {
	}
}

export class DashboardCardsData {
	// ADMIN
	public static readonly ASSETS = new DashboardCardInfo(
		BackgroundBlue,
		mdiDomain,
		"#27458d",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.assets", message: "IMMOBILI" }),
		/*i18n*/i18n._({ id: "dashboard.cards.actions-button.view-assets", message: "Vedi tutti gli immobili" }),
	)
	public static readonly SENT_MATCH = new DashboardCardInfo(
		BackgroundBlue,
		mdiStorePlus,
		"#27458d",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.sent-match", message: "PROPOSTE INVIATE" }),
		/*i18n*/i18n._({ id: "dashboard.cards.actions-button.view-sent-matches", message: "Vedi tutte le proposte" }),
	)
	public static readonly APPROVED_MATCH = new DashboardCardInfo(
		BackgroundBlue,
		mdiStoreCheck,
		"#27458d",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.approved-match", message: "MATCH APPROVATI" }),
		/*i18n*/i18n._({ id: "dashboard.cards.actions-button.view-approved-match", message: "Vedi tutti i match" }),
	)
	public static readonly HOT_ASSETS = new DashboardCardInfo(
		BackgroundRed,
		mdiFire,
		"#f9344e",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.hot-assets", message: "SITUAZIONI CALDE" }),
		/*i18n*/i18n._({ id: "dashboard.cards.actions-button.view-all-hot-assets", message: "Vedi tutte le proposte" })
	)
	public static readonly HOT_BRAND = new DashboardCardInfo(
		BackgroundRed,
		mdiFire,
		"#f9344e",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.hot-brands", message: "RICHIESTE BRAND" }),
		null,
	)
	public static readonly ACTIONS = new DashboardCardInfo(
		BackgroundTurquoise,
		mdiBallot,
		"#48b9b6",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.actions", message: "PROMEMORIA PER OGGI" }),
		/*i18n*/i18n._({ id: "dashboard.cards.actions-button.view-actions", message: "Vedi tutti" })
	)
	public static readonly VISITS = new DashboardCardInfo(
		BackgroundTurquoise,
		mdiCalendarBlankMultiple,
		"#48b9b6",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.visits", message: "PROSSIMI SOPRALLUOGHI" }),
		/*i18n*/i18n._({ id: "dashboard.cards.actions-button.view-actions", message: "Vedi tutti" })
	)

	// BRAND
	public static readonly COMPATIBLE_ASSETS = new DashboardCardInfo(
		BackgroundLilac,
		mdiDomain,
		"#b5a4ff",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.compatible_assets", message: "NUOVI IMMOBILI COMPATIBILI" }),
		/*i18n*/i18n._({ id: "dashboard.cards.titles.compatible_assets.view-all", message: "Vedi i nuovi immobili" }),
	)
	public static readonly SEARCH_AFFILIATES = new DashboardCardInfo(
		BackgroundBabyPowder,
		mdiAccountSearch,
		"#6bc6f1",
		null,
		null
	)

	// MICROJOB

	public static readonly RECEIVED_JOBS = new DashboardCardInfo(
		BackgroundBabyPowder,
		mdiAccountSearch,
		"#6bc6f1",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.pending-jobs", message: "INCARICHI IN CORSO" }),
		null
	)

	public static readonly CONCLUDED_JOBS = new DashboardCardInfo(
		BackgroundTurquoise,
		mdiStarCheckOutline,
		"#48b9b6",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.concluded_jobs", message: "INCARICHI COMPLETATI" }),
		null
	)

	//LANDLORD

	public static readonly MY_ASSETS = new DashboardCardInfo(
		BackgroundLightBlue,
		mdiDomain,
		"#1f659b",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.dash-my-assets", message: "I MIEI IMMOBILI" }),
		null
	)

	public static readonly CONVERSION_RATE = new DashboardCardInfo(
		BackgroundTurquoise,
		mdiStarCheckOutline,
		"#48b9b6",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.my-conversion-rate", message: "TASSO DI CONVERSIONE" }),
		null
	)

	public static readonly MEAN_TIME_CONTRACT_START = new DashboardCardInfo(
		BackgroundLilac,
		mdiClipboardTextClock,
		"#b5a4ff",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.mean-time-contract-start", message: "TEMPO MEDIO AVVIO PRATICA" }),
		null
	)

	public static readonly CONTRACT_VALUE = new DashboardCardInfo(
		BackgroundDeepBlue,
		mdiCashMultiple,
		"#184262",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.contract_value", message: "VALORE CONTRATTI" }),
		null
	)

	public static readonly JOB_VALUE = new DashboardCardInfo(
		BackgroundDeepBlue,
		mdiCashMultiple,
		"#184262",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.job_value", message: "GUADAGNO TOTALE DEL MESE" }),
		null
	)

	public static readonly JOB_COMPLETITION_RATE = new DashboardCardInfo(
		BackgroundLilac,
		mdiClipboardTextClock,
		"#b5a4ff",
		/*i18n*/i18n._({ id: "dashboard.cards.titles.jo-completition-rate", message: "TASSO DI COMPLETAMENTO INCARICHI" }),
		null
	)
}
